
export const AUTH_KEY = process.env.AUTH_KEY??"pmc-admin-auth";
export const BASE_API_URL = process.env.REACT_APP_API??"http://localhost:8000/";
export const API_CLIENT_ID = process.env.REACT_APP_API_CLIENT_ID??"2";
export const API_CLIENT_SECRET = process.env.REACT_APP_API_CLIENT_SECRET??"C7Z9ZkP8FQKDTOcxitUpCqoSrDWXLRrSMewHq5g8";

export const ROUTES = {
    AUTH_ROUTE: "/auth/login",
    DASHBOARD: "/admin/dashboard",
    ALL_USERS: "/admin/users",
    PENDING_APPROVAL_PAYMENTS: "/admin/payments/pending",
    PAYMENTS: "/admin/payments",
    INVOICES: "/admin/invoices",
    REPORTS_STATS: "/admin/reports/stats",
    REPORTS_PAYMENTS: "/admin/reports/payments",
    MONITORING: "/admin/reports/monitoring",


    ACCOUNT_DASHBOARD: "/account/:uid/dashboard",
    ACCOUNT_PENDING_APPROVAL_PAYMENTS: "/account/:uid/payments/pending",
    ACCOUNT_PAYMENTS: "/account/:uid/payments",
    ACCOUNT_INVOICES: "/account/:uid/invoices",
    ACCOUNT_REPORTS_STATS: "/account/:uid/reports/stats",
    ACCOUNT_REPORTS_PAYMENTS: "/account/:uid/reports/payments",
    ACCOUNT_MONITORING: "/account/:uid/reports/monitoring",
}